import React from "react";
import useNurses from "@hooks/useNurses";
import NurseSwitchContents from "./NurseSwitchContents";
import CustomModal from "@/components/modal/CustomModal";

interface NurseActiveSwitchProps {
  onClose: () => void;
  selectedGroupId?: string | null;
}

const NurseActiveSwitch: React.FC<NurseActiveSwitchProps> = ({
  onClose,
  selectedGroupId,
}) => {
  const { isLoading: nurseLoading } = useNurses(selectedGroupId);

  return (
    <CustomModal.Panel onClose={onClose} isLoading={nurseLoading}>
      <NurseSwitchContents
        onClose={onClose}
        selectedGroupId={selectedGroupId!}
      />
    </CustomModal.Panel>
  );
};

export default NurseActiveSwitch;
